import React, { useEffect, useRef, useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { HeadingWithCreateBtn, Search, Table } from 'src/components';
import DashboardLayout from 'src/containers/dashboard-layout';
import useFetch from 'src/hooks/useFetch';
import AddItems from './crud/AddItem';
import CrudIcon from 'src/components/crud-icon';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'src/components/button';
import { useDispatch } from 'react-redux';
import { fetchItemCategories } from 'src/redux/action/item.action';
import Service from 'src/setup/network';

interface IProps {}
export const addEditItems = (data: any) => {
  localStorage.setItem('editItemsData', JSON.stringify(data));
  return {
    type: 'EDIT_ITEMS',
    payload: data,
  };
};

const Items: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(false);
  const [editItemsId, setEditItemsId] = React.useState('');
  const [editItems, setEditItems] = React.useState(false);
  const navigate = useNavigate();
  const [query, setQuery] = React.useState('');
  const dispatch = useDispatch();
  const {
    data: itemsData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/items');

  React.useEffect(() => {
    dispatch(fetchItemCategories() as any);
  }, [dispatch]);
  const [data, setData] = useState([]);
  const [displayInWebsite, setDisplayInWebsite] = useState({});

  const searchItemsData = itemsData?.items?.filter((item: { name: string }) => {
    if (query === '') {
      return item;
    } else if (item?.name?.toLowerCase().includes(query.toLowerCase())) {
      return item;
    }
  });

  const handleEditItems = (data: any) => {
    setEditItemsId(data.id);
    dispatch(addEditItems(data));
    navigate('/edit-item');
    setShowModal(true);
    setEditItems(true);
  };

  // React.useEffect(() => {
  //   dispatch(fetchItemCategories() as any);
  //   if (itemsData?.items?.length > 0) {
  //     const displayInWebsiteData = itemsData.items.reduce(
  //       (acc: any, item: any) => {
  //         acc[item.id] = item.displayInWebsite;
  //         return acc;
  //       },
  //       {}
  //     );
  //     setDisplayInWebsite(displayInWebsiteData);
  //   }
  // }, [dispatch, itemsData]);

  // const handleCheckboxChange = async (id: any, currentValue: any) => {
  //   const newValue = !currentValue;
  //   try {
  //     const response: any = await Service.post(
  //       `items/toggle/displayInWebsite/${id}`
  //     );

  //     if (!response?.data?.success) {
  //       throw new Error('API call failed');
  //     }

  //     setDisplayInWebsite((prevState: any) => ({
  //       ...prevState,
  //       [id]: newValue,
  //     }));
  //   } catch (error) {
  //   }
  // };

  // const handleCheckboxChange = (id: any, currentValue: any) => {
  //   const newValue = !currentValue;
  //   setDisplayInWebsite((prevState) => ({
  //     ...prevState,
  //     [id]: newValue,
  //   }));
  // };

  // const IndeterminateCheckbox = React.forwardRef<
  //   HTMLInputElement,
  //   { val: any }
  // >(({ indeterminate, val, ...rest }, ref) => {
  //   const defaultRef = useRef<HTMLInputElement>(null);
  //   const resolvedRef: any = ref || defaultRef;

  //   useEffect(() => {
  //     if (resolvedRef.current) {
  //       resolvedRef.current.indeterminate = indeterminate;
  //     }
  //   }, [resolvedRef, indeterminate]);

  //   return (
  //     <>
  //       <input type="checkbox" defaultChecked={val}  ref={resolvedRef} {...rest} />
  //     </>
  //   );
  // });
  
  const tableColumn = [
    {
      Header: 'Item Name',
      accessor: 'nasme',
      Cell: (row: any) => (
        <div className="flex flex-row-reverse items-center space-x-4 justify-end gap-4">
          <p className="capitalize"> {row?.cell?.row?.original?.name} </p>
        </div>
      ),
    },
    {
      Header: 'Category',
      accessor: 'category.nasme',
      Cell: (row: any) => (
        <p className="capitalize">
          {' '}
          {row?.cell?.row?.original?.category?.name}{' '}
        </p>
      ),
    },
    {
      Header: 'Price',
      accessor: 'variants[0].price',
    },
    {
      Header: 'Cost Price',
      accessor: 'variants[0].costPrice',
    },
    {
      Header: 'Online Ordering',
      Cell: (row: any) => {
        const [isCheck, setIsCheck] = useState<any>(
          row?.cell?.row?.original?.displayInWebsite
        );
        const toggleDisplayInWebsite = async (row: any) => {
          setIsCheck(!isCheck);
          row.cell.row.original.displayInWebsite =
            !row.cell.row.original.displayInWebsite;
          try {
            const response = await Service.post(
              `items/toggle/displayInWebsite/${row?.cell?.row?.original?.id}`
            );
          } catch (err) {}
        };

        return (
          <div className="flex items-center justify-between  scale-[0.8]">
            <label className="items-center cursor-pointer toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative ">
              <div
                className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-500 ${
                  isCheck ? 'transform translate-x-full bg-primary' : ''
                }`}
              ></div>
              <input
                type="checkbox"
                name=""
                className="hidden"
                checked={row?.cell?.row?.original?.displayInWebsite}
                onChange={() => toggleDisplayInWebsite(row)}
              />
              <span className="ml-5 text-sm font-medium "></span>
            </label>
          </div>
        );
      },
    },

    {
      Header: 'Availability',
      Cell: (row: any) => {
        const [isCheckAvailable, setIsCheckAvailable] = useState<any>(
          row?.cell?.row?.original?.isAvailable
        );
        const toggleIsAvailable = async (row: any) => {
          setIsCheckAvailable(!isCheckAvailable);
          row.cell.row.original.isAvailable =
            !row.cell.row.original.isAvailable;
          try {
            await Service.post(
              `items/toggle/available/${row?.cell?.row?.original?.id}`
            );
          } catch (err) {}
        };

        return (
          <div className="flex items-center justify-between  scale-[0.8]">
            <label className="items-center cursor-pointer toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative ">
              <div
                className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-500 ${
                  row?.cell?.row?.original?.isAvailable
                    ? 'transform translate-x-full bg-primary'
                    : ''
                }`}
              ></div>

              <input
                type="checkbox"
                className="hidden"
                checked={false}
                onChange={() => toggleIsAvailable(row)}
              />
              <span className="ml-5 text-sm font-medium"></span>
            </label>
          </div>
        );
      },
    },
    {
      Header: 'Action',
      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          url="/items/remove"
          fetchData={fetchData}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEditItems(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];

  const handleNavigate = () => {
    localStorage.removeItem('editItemsData');

    navigate('/add-item', {
      state: {
        editItemsId,
        editItems,
      },
    });
  };

  return (
    <>
      <div className="w-fit min-w-full">
        <div className="w-full">
          <div className="w-full flex items-center justify-between mr-10 ">
            <Search
              placeholder="search items"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Item'}
              variant="primary"
              onClick={handleNavigate}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <div className="pb-10">
            <Table
              loading={isLoading}
              tableColumn={tableColumn}
              tableData={searchItemsData}
              pagination={true}
            />
          </div>
        </div>
        {/* 
      
          <AddItems 
          // fetchData={() => {}}
          // handleModal={handleModal}
          // editItem={editItems}
          // editItemsId={editItemsId}
          // setEditItemId={setEditItemId}
          // setEditItems={setEditItems}
        />
          
 */}
      </div>
    </>
  );
};

export default React.memo(Items);
